import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface SiteLayoutProps {
  children: React.ReactNode;
}
export function SiteLayout({
  children
}: SiteLayoutProps) {
  return <div className="flex min-h-screen w-full flex-col bg-warm" data-id="element-358" data-mp="34uv0s4t2eab3">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-navy focus:px-4 focus:py-3 focus:text-[14px] focus:font-semibold focus:text-white" data-id="element-359" data-mp="34xqzvwgnf514">
        Skip to main content
      </a>
      <Header data-id="element-360" data-mp="3itkzfovj8i1k" />
      <main id="main" className="flex-1" data-id="element-361" data-mp="3it2ve62mozj3">
        {children}
      </main>
      <Footer data-id="element-362" data-mp="3nn71kn42l3j4" />
    </div>;
}